// settings#referrals — copy-to-clipboard for the member's referral link.
import { registerPage } from "../first"

export const SettingsReferralsPage = {
  onDomReady(): void {
    const button = document.querySelector<HTMLButtonElement>("[data-referral-copy]")
    const input = document.querySelector<HTMLInputElement>("[data-referral-url]")
    if (!button || !input) return

    button.addEventListener("click", async () => {
      const original = button.textContent

      try {
        await navigator.clipboard.writeText(input.value)
      } catch {
        // Clipboard API needs a secure context and permission; selecting the
        // text at least leaves it one keystroke away.
        input.select()
      }

      button.textContent = "Copied"
      setTimeout(() => { button.textContent = original }, 1500)
    })
  },
}

registerPage("SettingsReferralsPage", SettingsReferralsPage)
